import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20201678"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row justify-content-evenly" }),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row justify-content-evenly" })
], -1))
const _hoisted_2 = { class: "d-flex flex-row flex-wrap justify-content-evenly" }
const _hoisted_3 = { class: "card-header mb-0 pb-1 pb-2 ps-2 pe-2" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "card-body pt-1 pb-2 ps-2 pe-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-text mb-0" }, "WhatsApp: ", -1))
const _hoisted_7 = { class: "card-text" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "card-text" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "footer" }
const _hoisted_13 = { class: "container-fluid" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "text-md-end footer-links d-none d-md-block" }

import { defineComponent, onMounted, reactive } from 'vue';
import ModalDorape from './ModalDorape.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const state = reactive({
    lstNome: Array<string>(
        "Fabiano Prado",
        "Fernando César",
        "Henrique Lessa",
        "Karla Vieira",
        "Rafael Soares",
    ),
    lstTelefone: Array<string>(
        "+55 (22) 99823-4036",
        "+55 (22) 98819-9663",
        "+55 (22) 99278-7367",
        "+55 (22) 98154-8812",
        "+55 (22) 98832-6684",
    ),
    lstEmail: Array<string>(
        "suporte@dorapesistemas.com.br",
        "suporte@dorapesistemas.com.br",
        "suporte@dorapesistemas.com.br",
        "suporte@dorapesistemas.com.br",
        "suporte@dorapesistemas.com.br"
    ),
    lstFuncao: Array<string>(
        "Desenvolvedor",
        "Desenvolvedor",
        "Desenvolvedor",
        "Suporte",
        "Suporte"
    ),

    telaPequena: true,
    mostrarSup: Boolean(),
});

onMounted(() => {
    setInterval(() => {
        if (window.innerWidth <= 1023) {
            state.telaPequena = true;
        } else {
            state.telaPequena = false;
        }
    }, 100);
});

function mostrarModalSuporte() {
    state.mostrarSup = true;
}

function modalResultSuporte() {
    state.mostrarSup = false;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalDorape, {
      visible: state.mostrarSup,
      title: "Contatos de suporte",
      usarModal: true,
      tamanhoMaximo: "80%",
      onModalResult: modalResultSuporte
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.lstNome, (n, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card border",
              key: i,
              style: {"width":"32%"}
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h5", _hoisted_4, _toDisplayString(n) + ": " + _toDisplayString(state.lstFuncao[i]), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("p", _hoisted_7, [
                  _createElementVNode("a", {
                    target: "_blank",
                    href: `https://wa.me/${state.lstTelefone[i].replace(/[^\d]/g, '')}`
                  }, _toDisplayString(state.lstTelefone[i]), 9, _hoisted_8)
                ]),
                _createElementVNode("p", _hoisted_9, [
                  (state.lstEmail[i].length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        _createTextVNode(" E-mail: "),
                        _createElementVNode("a", {
                          target: "_blank",
                          href: `https://mail.google.com/mail/?view=cm&fs=1&to=${state.lstEmail[i]}`
                        }, _toDisplayString(state.lstEmail[i]), 9, _hoisted_11)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createElementVNode("footer", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: _normalizeClass(["row", { ' d-flex flex-row': state.telaPequena == true }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["nome", { 'text-center col-12': state.telaPequena == true, 'col-6': state.telaPequena == false }])
          }, " Ágape Sistemas", 2),
          _withDirectives(_createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("a", {
                class: "pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (mostrarModalSuporte()))
              }, "Suporte")
            ])
          ], 512), [
            [_vShow, state.telaPequena == false]
          ])
        ], 2)
      ])
    ])
  ], 64))
}
}

})